import { adminModuleQuery, useModule } from 'system/structure-modules';

export default function AdminUsersScreen() {
    const { AdminUsersScreen } = useModule(adminModuleQuery);
    return <AdminUsersScreen />;
}
